module.exports = __webpack_public_path__ + "503792674b06ea2e14058cc2cdc3063c.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/video_player/blueoverlay_new.png
// module id = 183
// module chunks = 0